module.exports = __webpack_public_path__ + "static/media/bedroom.bb9a1b76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/interiors/bedroom.jpg
// module id = 358
// module chunks = 0